import React from "react";

function Tab(props) {
  return <div>{props.children}</div>;
}
export default Tab;
